import module from 'fanconsultores/module.js'
import template from './template.html'

const generarUrl = (location) => {
  return location.href.replace(location.origin, 'https://admin.fanconsultores.com')
}

class FanconsultoresAdminAppToolbarComponent {
  constructor ($scope, $window) {
    this.search = null
    this.user = null
    this.login = null
    this.logout = null
    this.appInterface = null
    this.altUrl = null

    $scope.$on('$locationChangeSuccess', () => (this.altUrl = generarUrl($window.location)))
  }

  buscar () {
    this.appInterface.view('buscar')
  }
}

module.component('fanconsultoresAdminAppToolbar', {
  controller: FanconsultoresAdminAppToolbarComponent,
  template,
  bindings: {
    search: '<',
    user: '<',
    login: '&',
    logout: '&',
  },
  require: {
    appInterface: '?^appInterface',
  },
})



// WEBPACK FOOTER //
// ./src/fanconsultores/components/fanconsultores/admin/app/toolbar/components.js